import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as H}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as o}from"../../icon-registry.js";const t=H`
    <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M2 19.6201V5.62012H3.81818V19.6201H2ZM4.72727 19.6201V5.62012H6.54545V19.6201H4.72727ZM7.45455 19.6201V5.62012H8.36364V19.6201H7.45455ZM10.1818 19.6201V5.62012H12V19.6201H10.1818ZM12.9091 19.6201V5.62012H15.6364V19.6201H12.9091ZM16.5455 19.6201V5.62012H17.4545V19.6201H16.5455ZM19.2727 19.6201V5.62012H22V19.6201H19.2727Z"
            fill="#FCFCFC" />
    </svg>
`,n=o("barcode",t),a=o("boleto_bancario",t);export{n as Barcode,a as BoletoBancario};
